export class LayoutType {
  root: any;
  pageNumber: number;

  constructor() {
    this.root = {};
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/types/layout-type.ts